import { PAYMENT_V2_ENDPOINT_V2 } from "@/components/Pricing/v2/constants.pricing";

export const CHECKOUT_SERVICE_BASE_URL = PAYMENT_V2_ENDPOINT_V2;

export const CHECKOUT_TYPE = {
  MANAGE: "plan_manage",
  PURCHASE: "plan_purchase",
  MIGRATION: "plan_migration",
} as const;

export const CHECKOUT_VARIANT = {
  MIGRATION: "migration_checkout",
  MANAGE: "manage_checkout",
  PURCHASE: "purchase_checkout",
  UNKNOWN: "unknown",
} as const;

/**
 * Per-checkout-type API endpoint mapping.
 * Each checkout flow hits different backend URLs.
 */
export const CHECKOUT_V2_ENDPOINTS = {
  plan_purchase: {
    summary: `${PAYMENT_V2_ENDPOINT_V2}/purchase/summary`,
    execute: `${PAYMENT_V2_ENDPOINT_V2}/purchase/execute`,
  },
  plan_manage: {
    summary: `${PAYMENT_V2_ENDPOINT_V2}/purchase/summary`,
    execute: `${PAYMENT_V2_ENDPOINT_V2}/purchase/execute`,
  },
  plan_migration: {
    summary: `${PAYMENT_V2_ENDPOINT_V2}/plan/migration`,
    execute: `${PAYMENT_V2_ENDPOINT_V2}/plan/migration/buy`,
  },
} as const;

export const DEFAULT_USAGE_STATS = [
  { number: "900", label: "Culled Images" },
  { number: "800", label: "Edited Images" },
  { number: "800", label: "Retouched Images" },
  { number: "60%", label: "Time saved" },
];

export const BUNDLE_DISCOUNT_RATE = 0.25;

export const DAYS_PER_MONTH = 30;
